import React, { useState, useEffect } from 'react';
import { Card, Table, Tag, Typography, Button, Space, Select, Form, Input, InputNumber, Modal, message, Drawer } from 'antd';
import { SearchOutlined, ReloadOutlined, PlusOutlined, PlayCircleOutlined, StopOutlined, DeleteOutlined, SettingOutlined, DashboardOutlined, EditOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import AgentObserve from './AgentObserve';

const { Title, Text } = Typography;

// TODO: 联调时替换为接口数据
const MOCK_MODEL_PRICING = {
    'doubao-vision-1.8': { inputPrice: 0.003, outputPrice: 0.012 },
    'deepseek-v4-flash': { inputPrice: 0.001, outputPrice: 0.004 },
    'deepseek-pro': { inputPrice: 0.004, outputPrice: 0.016 },
    'qwen-VL-Max': { inputPrice: 0.005, outputPrice: 0.020 },
};
const MOCK_AGENTS = [
    { key: '1', agentId: 'test-agent-001', name: 'test-家庭安防智能看护',
        status: 'published', modelName: 'doubao-vision-1.8',
        checkedRegions: ['国内'],
        estimatedInputTokens: 1.0, estimatedOutputTokens: 3.0,
        linkedServices: 1, linkedPackages: 3, updateTime: '2026-07-20 14:30:00',
        linkedServiceList: [{ name: 'AI家庭看护Agent', id: '400001' }],
        linkedList: [{ name: '家庭安防基础包', id: 'ID:5001' }, { name: '家庭安防尊享包', id: 'ID:5002' }, { name: '智能看护年包', id: 'ID:5100' }] },
    { key: '2', agentId: 'agent-pet-002', name: '宠物监护Agent',
        status: 'published', modelName: 'deepseek-v4-flash',
        checkedRegions: ['国内'],
        estimatedInputTokens: 0.8, estimatedOutputTokens: 2.5,
        linkedServices: 1, linkedPackages: 1, updateTime: '2026-07-19 10:00:00',
        linkedServiceList: [{ name: '宠物监护服务', id: '400002' }],
        linkedList: [{ name: '宠物监护月包', id: 'ID:6001' }] },
    { key: '3', agentId: 'agent-baby-003', name: '婴儿监护Agent',
        status: 'draft', modelName: 'deepseek-v4-flash',
        checkedRegions: ['国内', '北美'],
        estimatedInputTokens: 0.5, estimatedOutputTokens: 1.5,
        linkedServices: 0, linkedPackages: 0, updateTime: '2026-07-18 16:20:00', linkedServiceList: [], linkedList: [] },
    { key: '4', agentId: 'agent-elder-004', name: '老人看护Agent',
        status: 'draft', modelName: 'qwen-VL-Max',
        checkedRegions: ['国内', '亚太'],
        estimatedInputTokens: 1.2, estimatedOutputTokens: 4.0,
        linkedServices: 0, linkedPackages: 0, updateTime: '2026-07-17 09:00:00', linkedServiceList: [], linkedList: [] },
    { key: '5', agentId: 'agent-store-005', name: '门店安防Agent',
        status: 'published', modelName: 'doubao-vision-1.8',
        checkedRegions: ['国内'],
        estimatedInputTokens: 2.0, estimatedOutputTokens: 5.0,
        linkedServices: 2, linkedPackages: 2, updateTime: '2026-07-20 08:00:00',
        linkedServiceList: [{ name: '门店安防服务A', id: '400003' }, { name: '门店安防服务B', id: '400004' }],
        linkedList: [{ name: '门店安防标准包', id: 'ID:7001' }, { name: '门店安防高级包', id: 'ID:7002' }] },
    { key: '6', agentId: 'test-agent-off-006', name: 'test-旧版家庭安防',
        status: 'offline', modelName: 'doubao-vision-1.8',
        checkedRegions: ['国内'],
        estimatedInputTokens: 0, estimatedOutputTokens: 0,
        linkedServices: 0, linkedPackages: 0, updateTime: '2026-06-01 12:00:00', linkedServiceList: [], linkedList: [] },
];

const STATUS_MAP = {
    draft: { text: '草稿', color: 'default' },
    published: { text: '已发布', color: 'green' },
    offline: { text: '已下线', color: 'red' },
};

const AgentList = () => {
    const navigate = useNavigate();
    const [records, setRecords] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filters, setFilters] = useState({ agentName: '', agentId: '', status: undefined });
    const [observeDrawer, setObserveDrawer] = useState({ open: false, record: null });
    const [tokenModal, setTokenModal] = useState({ open: false, record: null });
    useEffect(() => { fetchRecords(); }, []); // eslint-disable-line

    const fetchRecords = () => {
        setLoading(true);
        setTimeout(() => { setRecords(MOCK_AGENTS); setLoading(false); }, 300);
    };

    const handleSearch = () => {
        setLoading(true);
        setTimeout(() => {
            let data = [...MOCK_AGENTS];
            if (filters.agentName) {
                data = data.filter(r => r.name.toLowerCase().includes(filters.agentName.toLowerCase()));
            }
            if (filters.agentId) {
                data = data.filter(r => r.agentId.toLowerCase().includes(filters.agentId.toLowerCase()));
            }
            if (filters.status) data = data.filter(r => r.status === filters.status);
            setRecords(data);
            setLoading(false);
        }, 200);
    };

    const handleReset = () => { setFilters({ agentName: '', agentId: '', status: undefined }); fetchRecords(); };

    const handlePublish = (record) => {
        Modal.confirm({
            title: '发布Agent',
            content: `发布后「${record.name}」可被套餐服务引用，确认发布？`,
            okText: '确认发布',
            onOk: () => {
                setRecords(prev => prev.map(r => r.key === record.key ? { ...r, status: 'published' } : r));
                message.success(`「${record.name}」已发布`);
            },
        });
    };

    const handleOffline = (record) => {
        Modal.confirm({
            title: '下线Agent',
            content: `下线后新设备无法激活「${record.name}」，已购套餐不受影响，确认下线？`,
            okText: '确认下线',
            onOk: () => {
                setRecords(prev => prev.map(r => r.key === record.key ? { ...r, status: 'offline' } : r));
                message.success(`「${record.name}」已下线`);
            },
        });
    };

    const handleDelete = (record) => {
        if (record.linkedPackages > 0) {
            Modal.warning({
                title: '无法删除',
                content: `「${record.name}」被 ${record.linkedPackages} 个套餐服务引用，无法删除。请先取消所有套餐服务关联。`,
            });
            return;
        }
        Modal.confirm({
            title: '删除Agent',
            content: `确定删除「${record.name}」？删除后不可恢复。`,
            okText: '确认删除',
            okType: 'danger',
            onOk: () => {
                setRecords(prev => prev.filter(r => r.key !== record.key));
                message.success(`「${record.name}」已删除`);
            },
        });
    };

    const calcCost = (record) => {
        const pricing = MOCK_MODEL_PRICING[record.modelName] || { inputPrice: 0, outputPrice: 0 };
        const inputCost = (record.estimatedInputTokens || 0) * pricing.inputPrice;
        const outputCost = (record.estimatedOutputTokens || 0) * pricing.outputPrice;
        return { inputCost, outputCost, totalCost: inputCost + outputCost, pricing };
    };

    const handleTokenEdit = (record) => {
        setTokenModal({ open: true, record, inputVal: record.estimatedInputTokens, outputVal: record.estimatedOutputTokens });
    };

    const handleTokenSave = () => {
        const { record, inputVal, outputVal } = tokenModal;
        setRecords(prev => prev.map(r => r.key === record.key ? { ...r, estimatedInputTokens: inputVal, estimatedOutputTokens: outputVal } : r));
        message.success('预计Token已更新');
        setTokenModal({ open: false, record: null });
    };

    const columns = [
        { title: 'Agent名称', key: 'name', render: (_, r) => (
            <Button type="link" style={{ padding: 0 }} onClick={() => navigate(`/agent/config/${r.key}`)}>{r.name}</Button>
        )},
        { title: 'Agent ID', dataIndex: 'agentId', width: 180,
            render: (v) => <Space><Text copyable={{ text: v }} style={{ fontFamily: 'monospace', fontSize: 12 }}>{v}</Text></Space> },
        { title: '状态', dataIndex: 'status', width: 80,
            render: (v) => { const s = STATUS_MAP[v] || { text: v, color: 'default' }; return <Tag color={s.color} style={{ border: 'none' }}>{s.text}</Tag>; } },
        { title: '服务区域', key: 'regions', width: 150,
            render: (_, r) => {
                if (!r.checkedRegions || r.checkedRegions.length === 0) return <span style={{ color: '#ccc' }}>--</span>;
                return r.checkedRegions.map(label => (
                    <Tag key={label} color="green" style={{ border: 'none', marginRight: 4, marginBottom: 4 }}>{label}</Tag>
                ));
            },
        },
        { title: '更新时间', dataIndex: 'updateTime', width: 170 },
        { title: '预计token', key: 'estimatedTokens', width: 150,
            render: (_, r) => (
                <div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Text style={{ fontSize: 12 }}>输入:{(r.estimatedInputTokens || 0).toFixed(2)}百万</Text>
                        <EditOutlined style={{ color: '#999', cursor: 'pointer', fontSize: 12 }}
                            onClick={() => handleTokenEdit(r)} />
                    </div>
                    <Text style={{ fontSize: 12 }}>输出:{(r.estimatedOutputTokens || 0).toFixed(2)}百万</Text>
                </div>
            ),
        },
        { title: '总成本', key: 'totalCost', width: 280,
            render: (_, r) => {
                const { inputCost, outputCost, totalCost, pricing } = calcCost(r);
                return (
                    <div>
                        <Text strong style={{ fontSize: 12 }}>¥{totalCost.toFixed(4)}</Text>
                        <div><Text type="secondary" style={{ fontSize: 11 }}>
                            {(r.estimatedInputTokens || 0).toFixed(2)}百万 × ¥{pricing.inputPrice.toFixed(4)}/百万token = ¥{inputCost.toFixed(4)}
                        </Text></div>
                        <div><Text type="secondary" style={{ fontSize: 11 }}>
                            {(r.estimatedOutputTokens || 0).toFixed(2)}百万 × ¥{pricing.outputPrice.toFixed(4)}/百万token = ¥{outputCost.toFixed(4)}
                        </Text></div>
                    </div>
                );
            },
        },
        { title: '操作', key: 'action', width: 350, fixed: 'right',
            render: (_, r) => (
                <Space size={4}>
                    <Button type="link" size="small" icon={<SettingOutlined />} onClick={() => navigate(`/agent/config/${r.key}`)}>配置</Button>
                    <Button type="link" size="small" icon={<DashboardOutlined />} onClick={() => setObserveDrawer({ open: true, record: r })}>运行观测</Button>
                    {r.status === 'draft' && (
                        <Button type="link" size="small" icon={<PlayCircleOutlined />} onClick={() => handlePublish(r)}>发布</Button>
                    )}
                    {r.status === 'published' && (
                        <Button type="link" size="small" icon={<StopOutlined />} onClick={() => handleOffline(r)}>下线</Button>
                    )}
                    {r.status === 'offline' && (
                        <Button type="link" size="small" icon={<PlayCircleOutlined />} onClick={() => handlePublish(r)}>重新发布</Button>
                    )}
                    {(r.status === 'draft' || r.status === 'offline') && (
                        <Button type="link" size="small" danger icon={<DeleteOutlined />}
                            disabled={r.linkedPackages > 0}
                            onClick={() => handleDelete(r)}>删除</Button>
                    )}
                </Space>
            ),
        },
    ];

    return (
        <div style={{ padding: 24 }}>
            <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Title level={4} style={{ margin: 0 }}>Agent管理</Title>
                <Button type="primary" icon={<PlusOutlined />} onClick={() => navigate('/agent/config/new')}>创建Agent</Button>
            </div>
            <Card bordered={false} style={{ marginBottom: 8, borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }}>
                <Form layout="inline">
                    <Form.Item style={{ marginBottom: 0 }}>
                        <Input placeholder="Agent名称" allowClear style={{ width: 180 }}
                            value={filters.agentName} onChange={(e) => setFilters(prev => ({ ...prev, agentName: e.target.value }))} />
                    </Form.Item>
                    <Form.Item style={{ marginBottom: 0 }}>
                        <Input placeholder="Agent ID" allowClear style={{ width: 220 }}
                            value={filters.agentId} onChange={(e) => setFilters(prev => ({ ...prev, agentId: e.target.value }))} />
                    </Form.Item>
                    <Form.Item style={{ marginBottom: 0 }}>
                        <Select allowClear placeholder="状态" style={{ width: 120 }}
                            value={filters.status} onChange={(v) => setFilters(prev => ({ ...prev, status: v }))}
                            options={[{ label: '草稿', value: 'draft' }, { label: '已发布', value: 'published' }, { label: '已下线', value: 'offline' }]} />
                    </Form.Item>
                    <Form.Item style={{ marginBottom: 0 }}>
                        <Space><Button type="primary" icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>
                            <Button icon={<ReloadOutlined />} onClick={handleReset}>重置</Button></Space>
                    </Form.Item>
                </Form>
            </Card>
            <Card bordered={false} style={{ borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }}>
                <Table columns={columns} dataSource={records} loading={loading} rowKey="key"
                    pagination={{ showSizeChanger: true, showTotal: (t) => `共 ${t} 条记录` }}
                    scroll={{ x: 1600 }}
                    locale={{ emptyText: records.length === 0 && !loading ? (
                        <div style={{ padding: 40 }}>
                            <Text type="secondary" style={{ fontSize: 14, display: 'block', marginBottom: 16 }}>暂无Agent，点击右上角创建第一个Agent</Text>
                        </div>
                    ) : '暂无数据' }} />
            </Card>

            <Drawer title={`运行观测 — ${observeDrawer.record?.name || ''}`} open={observeDrawer.open}
                onClose={() => setObserveDrawer({ open: false, record: null })} width={960}>
                {observeDrawer.record && <AgentObserve agentName={observeDrawer.record.name} />}
            </Drawer>

            <Modal title="编辑预计Token" open={tokenModal.open}
                onCancel={() => setTokenModal({ open: false, record: null })}
                onOk={handleTokenSave} width={400}>
                <div style={{ marginBottom: 16 }}>
                    <Text type="secondary" style={{ fontSize: 12 }}>可多次调试Agent获取token使用情况，作为填写预计token依据</Text>
                </div>
                <Form layout="vertical">
                    <Form.Item label="预计输入token（百万）">
                        <InputNumber min={0} step={0.01} precision={2} style={{ width: '100%' }}
                            value={tokenModal.inputVal}
                            onChange={(v) => setTokenModal(prev => ({ ...prev, inputVal: v }))} />
                    </Form.Item>
                    <Form.Item label="预计输出token（百万）">
                        <InputNumber min={0} step={0.01} precision={2} style={{ width: '100%' }}
                            value={tokenModal.outputVal}
                            onChange={(v) => setTokenModal(prev => ({ ...prev, outputVal: v }))} />
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
};

export default AgentList;
